import { render } from "./payment-methods-settings.vue?vue&type=template&id=3b419084&scoped=true&ts=true"
import script from "./payment-methods-settings.ts?vue&type=script&lang=ts"
export * from "./payment-methods-settings.ts?vue&type=script&lang=ts"

import "./payment-methods-settings.scss?vue&type=style&index=0&id=3b419084&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b419084"]])

export default __exports__